<script setup lang="ts">
import PageContainer from "~/components/ui/PageContainer.vue";
import { pythonInteractiveCards } from "~/features/python/data/chapter2-interactive";

const solvedLinks = [
  { title: "Python Notes", to: "/11th/computer/python/notes/", description: "Definitions aur base concepts dobara revise karo." },
  { title: "Python MCQs", to: "/11th/computer/python/mcqs/", description: "Objective practice with explanations." },
  { title: "Short Questions", to: "/11th/computer/python/short-questions/", description: "Important exam prompts ke short answers." },
  { title: "Long Questions", to: "/11th/computer/python/long-questions/", description: "Structured answers for descriptive prep." },
  { title: "Practice Exercise", to: "/11th/computer/python/exercise/", description: "Quick revision aur weak-area follow-up." },
];

usePageSeo({
  title: "11th Class Python Solved Exercise - Chapter 2",
  description: "Focused solved-exercise entry for 11th class Python chapter with links to notes, MCQs, short questions and long questions.",
  keywords: "11th class python solved exercise, chapter 2 complete solution, fsc python solved exercise",
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th Computer", item: "/11th/computer/" },
    { name: "Python", item: "/11th/computer/python/" },
    { name: "Solved Exercise", item: "/11th/computer/python/solved-exercise/" },
  ],
});
</script>

<template>
  <PageContainer>
    <div class="space-y-8">
      <section class="space-y-4 rounded-3xl bg-slate-950 p-6 text-white">
        <h1 class="text-2xl font-bold tracking-tight">11th Class Python Solved Exercise</h1>
        <p class="text-sm leading-7 text-slate-200">
          Is page se aap solved exercise ke sath notes, MCQs aur important topic pages tak ja saktay hain.
        </p>
      </section>

      <section class="grid gap-3">
        <NuxtLink v-for="link in solvedLinks" :key="link.to" :to="link.to" class="rounded-3xl border border-slate-200 bg-white p-5 transition hover:border-sky-300 hover:bg-sky-50">
          <h2 class="text-lg font-semibold text-slate-900">{{ link.title }}</h2>
          <p class="mt-2 text-sm leading-7 text-slate-600">{{ link.description }}</p>
        </NuxtLink>
      </section>

      <section class="rounded-3xl border border-slate-200 bg-slate-50 p-5">
        <div>
          <p class="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">More Python Topics</p>
          <h2 class="mt-2 text-lg font-semibold text-slate-900">Topic clear karna hai?</h2>
        </div>
        <div class="mt-4 grid gap-3 md:grid-cols-2">
          <NuxtLink
            v-for="item in pythonInteractiveCards"
            :key="item.to"
            :to="item.to"
            class="rounded-2xl border border-slate-200 bg-white p-4 transition hover:border-sky-300 hover:bg-sky-50"
          >
            <h3 class="text-sm font-semibold text-slate-900">{{ item.title }}</h3>
            <p class="mt-2 text-sm leading-6 text-slate-600">{{ item.description }}</p>
          </NuxtLink>
        </div>
      </section>
    </div>
  </PageContainer>
</template>
